var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"error-scan-container"},[_c('div',[_c('Icon',{staticClass:"icon-error",attrs:{"type":"md-alert"}}),_c('p',[_vm._v(_vm._s(_vm.desc))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }